export default { sha: '8765217d8fb54f4bb04d7014e762c8bea55ba74e', buildNumber: 'undefined' }
